import { render, staticRenderFns } from "./ReassignModal.vue?vue&type=template&id=33ab41c7&scoped=true"
import script from "./ReassignModal.vue?vue&type=script&lang=js"
export * from "./ReassignModal.vue?vue&type=script&lang=js"
import style0 from "./ReassignModal.vue?vue&type=style&index=0&id=33ab41c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab41c7",
  null
  
)

export default component.exports